export default __webpack_public_path__ + "static/media/down-white-small.7eba2afb.svg";